import useDropdown from "../util/hooks/useDropDown";
import CustomButton from "./CustomButton";

export default function AttendanceReportDropDown({
  menuItems,
  buttonText = "Attendance Report",
}) {
  const { isOpen, toggleDropdown, dropdownRef } = useDropdown();

  return (
    <div className="relative" ref={dropdownRef}>
      <div className="flex justify-end items-end">
        <CustomButton
          text={buttonText}
          color="bg-success-700"
          iconPosition="right"
          onClick={toggleDropdown}
        />
      </div>

      <div
        className={`absolute right-0 mt-2 max-w-52 p-2 bg-white rounded-lg shadow-xl
        z-20 transition-all duration-200 
        ${isOpen ? "opacity-100 visible" : "opacity-0 invisible"}`}
      >
        <ul className="flex flex-col gap-2 py-3 text-sm text-neutral-600 font-medium">
          {menuItems?.map((item) => (
            <li
              key={item.label}
              onClick={() => item.onClick?.() || item.link?.()}
              className="px-4 py-2 cursor-pointer rounded-md hover:bg-background-300"
            >
              {item.label}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
